import React, { useState, useEffect, useCallback } from "react";
import {
  Button,
  FormControl,
  Text,
  Image,
  useColorModeValue,
  Grid,
  GridItem,
  Icon,
  Flex,
} from "@chakra-ui/react";
import Webcam from "react-webcam";
import {
  MdOutlineCameraAlt,
  MdOutlineNoPhotography,
  MdOutlineCheck,
} from "react-icons/md";
import Card from "components/card/Card";
import { useDropzone } from "react-dropzone";
import PopOverAlert from "components/popAlert/popAlert";
import { IsEmpty } from "config/functions";

export default function Camera(props: {
  dataUser: any;
  handleFoto: any;
  cpfBusca: any;
  dtNascimento: any;
  nomeUser: any;
  cep: any;
}) {
  const { dataUser, handleFoto, cpfBusca, dtNascimento, nomeUser, cep } = props;
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const [image, setImage] = useState<string | null>(null);
  const [imageUpload, setImageUpload] = useState<string | null>(null);
  const bgBar = useColorModeValue("secondaryGray.100", "whiteAlpha.100");
  const textColorSecondary = "secondaryGray.600";
  const [date, setDate] = useState(new Date());
  const [nome, setNome] = useState("");
  const [statusPopOver, setStatusPopOver] = useState("warning");
  const [titlePopOver, setTitlePopOver] = useState("Ops...");
  const [subtitlePopOver, setSubtitlePopOver] = useState("");
  const [statusFotoMultiFace, setStatusFotoMultiFace] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const [recoverLoggedUser, setRecoverLoggedUser] = useState([
    JSON.parse(localStorage.getItem("user")),
  ]);

  const usuarios = [
    {
      perfis: recoverLoggedUser[0]?.perfis,
    },
  ];

  const perfisPermitidosForce = [
    "ADMINISTRADOR",
    "SUPERVISOR_LOJA",
    "ATENDENTE_LOJA",
  ];

  const algumUsuarioCompativelForce = usuarios.some((usuario) =>
    usuario.perfis.some((perfil: any) => perfisPermitidosForce.includes(perfil))
  );

  const handleOpenAlert = (status: boolean) => {
    setIsOpen(status);
  };

  const showPopOver = (status: string, title: string, subtitle: string) => {
    handleOpenAlert(true);
    setStatusPopOver(status);
    setTitlePopOver(title);
    setSubtitlePopOver(subtitle);
  };

  const newImage = () => {
    setImage(null);
    handleFoto("");
  };

  const webcamRef = React.useRef<Webcam>(null);

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current?.getScreenshot({
      width: 1080,
      height: 720,
    });
    if (imageSrc) {
      setImage(imageSrc);
      setStatusFotoMultiFace("");
      setIsLoading(true);
    }
  }, [webcamRef, dataUser, cpfBusca]);

  const captureForce = useCallback(() => {
    if (!IsEmpty(dataUser?.dataNascimento)) {
      const imageSrc = webcamRef.current?.getScreenshot({
        width: 1080,
        height: 720,
      });
      if (imageSrc) {
        setImage(imageSrc);
        setStatusFotoMultiFace("");
        setIsLoading(true);
      }
    }
  }, [webcamRef, dataUser, cpfBusca]);

  const videoConstraints = {
    width: 1080,
    height: 720,
    screenshotQuality: 1,
    facingMode: "user",
  };

  useEffect(() => {
    if (IsEmpty(dataUser)) {
      setNome(nomeUser);
      setDate(dtNascimento);
    } else {
      setNome(dataUser.nome);
      setDate(dataUser.date);
    }
  }, [nomeUser, dtNascimento, dataUser, cep, cpfBusca]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (acceptedFiles) => {
      const file = acceptedFiles[0];
      const reader = new FileReader();
      reader.onloadend = () => {
        // A URL de dados da imagem é acessada aqui
        if (reader.result) {
          const fileContent = reader.result as string;
          setImageUpload(fileContent);
          setStatusFotoMultiFace("");
        }
      };

      if (file) {
        reader.readAsDataURL(file);
      }
    },
  });

  // @ts-ignore
  return (
    <>
      <PopOverAlert
        handleOpenAlert={handleOpenAlert}
        isOpen={isOpen}
        status={statusPopOver}
        title={titlePopOver}
        subtitle={subtitlePopOver}
      />
      <FormControl {...dataUser}>
        <Grid
          h="10px"
          w="100%"
          templateRows={IsEmpty(dataUser) ? "repeat(2, 1fr)" : "repeat(1, 1fr)"}
          templateColumns={
            IsEmpty(dataUser) ? "repeat(5, 1fr)" : "repeat(3, 1fr)"
          }
          gap={1}
          alignItems={"center"}
        >
          <GridItem rowSpan={IsEmpty(dataUser) ? 2 : 0} colSpan={3}>
            {statusFotoMultiFace !== "Foto válida!" ? (
              <>
                <Flex direction={"column"} alignItems={"center"}>
                  <Card
                    mr="12px"
                    width={image || imageUpload ? "60%" : "100%"}
                    bg={bgBar}
                    alignItems={"center"}
                    borderRadius="250px"
                  >
                    <Webcam
                      style={{ borderRadius: 200 }}
                      audio={false}
                      mirrored={true}
                      imageSmoothing={true}
                      ref={webcamRef}
                      width="100%"
                      screenshotFormat="image/jpeg"
                      videoConstraints={videoConstraints}
                    />
                  </Card>
                  {statusFotoMultiFace && (
                    <Text
                      fontSize="md"
                      color={
                        statusFotoMultiFace !== "Foto válida!"
                          ? "red.500"
                          : "green.500"
                      }
                      fontWeight="700"
                    >
                      <Icon
                        as={
                          statusFotoMultiFace !== "Foto válida!"
                            ? MdOutlineNoPhotography
                            : MdOutlineCheck
                        }
                        width="25px"
                        height="25px"
                        color="inherit"
                      />
                      {statusFotoMultiFace}
                    </Text>
                  )}
                </Flex>
              </>
            ) : (
              <>
                <Flex direction={"column"} alignItems={"center"}>
                  <Card
                    bg="green.300"
                    width={IsEmpty(dataUser) ? "100%" : "60%"}
                    borderRadius="250px"
                  >
                    <Image
                      width="100%"
                      borderRadius="250px"
                      src={image || imageUpload}
                      objectFit="cover"
                      height="200"
                    />
                  </Card>
                  <Text
                    fontSize="md"
                    color={
                      statusFotoMultiFace !== "Foto válida!"
                        ? "red.500"
                        : "green.500"
                    }
                    fontWeight="700"
                  >
                    <Icon
                      as={
                        statusFotoMultiFace !== "Foto válida!"
                          ? MdOutlineNoPhotography
                          : MdOutlineCheck
                      }
                      width="20px"
                      height="20px"
                      color="inherit"
                    />
                    {statusFotoMultiFace}
                  </Text>
                </Flex>
              </>
            )}
          </GridItem>

          <>
            <GridItem colSpan={IsEmpty(dataUser) ? 2 : 3}>
              {statusFotoMultiFace !== "Foto válida!" ? (
                <Text
                  mt={IsEmpty(dataUser) ? null : "32px"}
                  color={textColor}
                  fontSize="20"
                  fontWeight="400"
                >
                  Enquadre o face no centro da câmera!
                  <Text
                    fontSize="md"
                    color={textColorSecondary}
                    fontWeight="300"
                  >
                    Para melhor definição, tire a foto com o cliente parado
                  </Text>
                </Text>
              ) : (
                <Text
                  mt={IsEmpty(dataUser) ? null : "32px"}
                  color={textColor}
                  fontSize="20"
                  fontWeight="400"
                >
                  Foto aprovada!
                </Text>
              )}
            </GridItem>

            {statusFotoMultiFace !== "Foto válida!" && (
              <GridItem colSpan={IsEmpty(dataUser) ? 2 : 3} mt={"-30px"}>
                <Button
                  colorScheme="green"
                  fontSize="sm"
                  mt="30px"
                  w="35%"
                  borderRadius="16px"
                  p="25px"
                  isLoading={isLoading}
                  leftIcon={<MdOutlineCameraAlt size="20px" />}
                  onClick={capture}
                >
                  Tirar Foto
                </Button>
                {algumUsuarioCompativelForce && (
                  <Button
                    colorScheme="orange"
                    fontSize="sm"
                    mt="30px"
                    w="45%"
                    borderRadius="16px"
                    p="25px"
                    ml={"15px"}
                    isLoading={isLoading}
                    leftIcon={<MdOutlineCameraAlt size="20px" />}
                    onClick={captureForce}
                  >
                    Forçar Foto
                  </Button>
                )}
                <section
                  {...getRootProps()}
                  style={{
                    border: "2px dashed gray",
                    padding: "20px",
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                >
                  <input {...getInputProps()} />
                  {isDragActive ? (
                    <p>Drop the files here ...</p>
                  ) : (
                    <p>
                      Drag 'n' drop some files here, or click to select files
                    </p>
                  )}
                </section>
              </GridItem>
            )}
          </>
        </Grid>
      </FormControl>
    </>
  );
}
